import { render, staticRenderFns } from "./history.vue?vue&type=template&id=7bfd2b76&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style1 from "./history.vue?vue&type=style&index=1&id=7bfd2b76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd2b76",
  null
  
)

export default component.exports